"use strict";

require("core-js/modules/es6.object.freeze");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 10;\n  padding: 3em;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  transition: 450ms;\n  & > div {\n    width: 640px;\n    min-width: 640px;\n    max-width: 640px;\n    background: transparent;\n    margin: 0 auto;\n    padding: 0;\n    @media (max-width: 45em) {\n      min-height: 100%;\n      display: flex;\n      flex-grow: 1;\n    }\n  }\n  div.panel {\n    background: white;\n    border-radius: 12px;\n    box-shadow: 0 .5em 1em 0 rgba(0, 0, 25, 0.075);\n    border: 1px solid ", ";\n    button {\n      transition: 200ms;\n    }\n    &__header {\n      .message {\n        padding: 0.75em 3.5em;\n        font-size: 14px;\n        color: ", ";\n        font-weight: 500;\n        border-bottom: 4px solid ", ";\n        &.lead {\n          margin: 0;\n          padding: 1.25em 1.75em 0.75em;\n          color: ", ";\n          font-size: 28px;\n        }\n        &.center {\n          text-align: center;\n        }\n      }\n    }\n    &__content {\n      padding: 2em 3em 4em;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      div.value-props {\n        padding: 0 0 1.5em;\n        li {\n          display: flex;\n          align-items: center;\n          margin-bottom: 1.5em;\n          line-height: 130%;\n        }\n        svg {\n          height: 32px;\n          width: 32px;\n          min-height: 32px;\n          min-width: 32px;\n          max-height: 32px;\n          max-width: 32px;\n          margin-right: 0.75em;\n        }\n        path {\n          fill: ", ";\n        }\n      }\n      button, input, select {\n        margin: 4px 0 12px;\n      }\n    }\n    &__footer {\n      text-align: center;\n      border-top: 1px solid ", ";\n      background: ", ";\n      font-size: 15px;\n      color: ", ";\n      line-height: 140%;\n      font-weight: 400;\n      .message {\n        padding: 1.25em 2em;\n      }\n    }\n    @media (max-width: 45em) {\n      display: flex;\n      flex-direction: column;\n      border-radius: 0;\n      box-shadow: none;\n      &__header {\n        .message, .message.lead {\n          padding: 1em 2.5em;\n          font-size: 15px;\n          text-align: initial;\n          &.center {\n            text-align: center;\n          }\n        }\n      }\n      &__content {\n        padding: 2em 2em 2.5em;\n      }\n      &__footer {\n        margin-top: auto\n        .message {\n          padding: 1em;\n        }\n      }\n    }\n  }\n  @media (max-width: 45em) {\n    padding: 0;\n    & > div {\n      width: 100%;\n      min-width: 100%;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Panel = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.colors.white['500'];
}, function (props) {
  return props.theme.colors.gray['900'];
}, function (props) {
  return props.theme.colors.brand['500'];
}, function (props) {
  return props.theme.colors.gray['500'];
}, function (props) {
  return props.theme.colors.brand['500'];
}, function (props) {
  return props.theme.colors.white['700'];
}, function (props) {
  return props.theme.colors.white['800'];
}, function (props) {
  return props.theme.colors.gray['800'];
});

var _default = Panel;
exports["default"] = _default;